import React, {useEffect} from "react";

// IMPORT COMPONENTS
import Navbar from "components/navBar/Navbar";
import MediaQuery from "react-responsive";
import SidebarDesktop from "components/sidebar/sidebarDesktop";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import EmptyStateCompany from "components/emptyState";
import Intercom from '@intercom/messenger-js-sdk';
import CryptoJS from 'crypto-js';
import useFetchData from "../../hooks/useFetchData";

const PageForm = (props) => {
    const {userData} = useFetchData();

    useEffect(() => {
        if (Object.keys(userData).length > 0) {
            const userIdentifier = userData._id.toString();
            const hash = CryptoJS.HmacSHA256(userIdentifier, process.env.REACT_APP_INTERCOM_ID).toString();
            Intercom({
                app_id: 'hq7jtuxz',
                user_id: userData._id,
                user_hash: hash,
                name: userData.firstname + ' ' + userData.lastname,
                email: userData.email,
                created_at: userData.createdAt,
                custom_attributes: {
                    userType: "company",
                },
            });
        }
    }, [userData]);

    return (
        <>
            <MediaQuery minWidth={900}>
            <div className="flex h-screen overflow-y-hidden tab:overflow-hidden">
                {/* Sidebar */}
                <SidebarDesktop/>
                {/* Content area */}
                <div className="flex flex-col flex-1 min-h-0 overflow-y-auto overflow-x-hidden" style={{ scrollbarGutter: 'stable' }}>
                    {/* Navbar */}
                    <Navbar></Navbar>
                    <main className="flex flex-col flex-1 min-h-0">
                        {/* SubNav */}
                        {/*<div className="w-full">*/}
                        {/*    <SecondNavBar/>*/}
                        {/*</div>*/}
                        {/* Main Content (pas de gap global: chaque page gère ses marges) */}
                        <div className="flex flex-col flex-1 min-h-0 w-full bg-white tab:pb-0 pb-20">{props.children}</div>
                    </main>
                </div>
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                limit={2}
                pauseOnFocusLoss
                draggable
            />
            </MediaQuery>
            <MediaQuery maxWidth={899}>
                <EmptyStateCompany type={'desktop'}/>
            </MediaQuery>
        </>
    );
};

export default PageForm;